import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { TelaGrupoMenusService } from './tela-grupo-menus.service';
import { Location } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { EncriptyUtilService } from '../../../../shared/services/encripty-util.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { DatatableService } from '../../../../shared/services/datatable.service';
import { CommonService } from '../../../../shared/services/commom.service';
import { ModalCancelarGrupoComponent } from './modal-cancelar-grupo/modal-cancelar-grupo.component';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'ngx-tela-grupo-menus',
  templateUrl: './tela-grupo-menus.component.html',
  styleUrls: ['./tela-grupo-menus.component.scss']
})
export class TelaGrupoMenusComponent implements OnInit, OnDestroy {

  public spinnerLoad: boolean = false;

  public formMenusGrupo: FormGroup = null;
  private grupoId: any = null;
  private public: any = null;
  private produtoId: any = null;
  private produtoNome: any = null;
  public grupoDescription: any = null;
  private listMenus: any = [];
  public listMenusTree: any = [];
  private listGrupoMenus: any = [];

  @ViewChild('myTable', null)
  public table: DatatableComponent;
  public customLogin = null;
  public showId = false;
  formListGrupo: any;
  locastyle: any;
  public listCardStatus = null;
  public descricao = null;
  public produto = null;
  public status = null;
  public listaProduto: any = [];
  public statusTodos = 'Desativar todos';
  public rowData: any = [];
  public listRegraGrupo: any = [];
  public listMe: any = [];
  public titleRegra = '(*) clicar no ícone para ser expandido o grupo que deseja ativar.'

  constructor(
    private route: ActivatedRoute,
    private notifications: NotificationsService,
    private formBuilder: FormBuilder,
    private service: TelaGrupoMenusService,
    private encriptyService: EncriptyUtilService,
    private location: Location,
    private datatableService: DatatableService,
    private commonService: CommonService,
    private dialogService: NbDialogService,
    private router: Router,
  ) {

    this.route.queryParamMap.subscribe(params => {
      this.grupoId = this.encriptyService.decriptyBySecretKey(params.get('grupoId'));
      this.produtoId = this.encriptyService.decriptyBySecretKey(params.get('produtoId'));
      this.produtoNome = this.encriptyService.decriptyBySecretKey(params.get('produtoNome'));
      this.descricao = this.encriptyService.decriptyBySecretKey(params.get('descricao'));
      this.status = this.encriptyService.decriptyBySecretKey(params.get('status'));
    });

    this.listCardStatus = [

      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },

      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },

    ];

    this.formMenusGrupo = this.formBuilder.group({
      grupoId: [this.grupoId],
      produtoId: [this.produtoId],
      id: [null],
      descricao: [null, Validators.required],
      status: [null, Validators.required],
      produto: [null, Validators.required],
    });

    this.service.searchGrupoById(this.grupoId)
      .subscribe(response => this.grupoDescription = response['descricao'])

    this.commonService.buscaProdutos()
      .subscribe(
        response => (
          this.listaProduto = response
        ));
  }

  async ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.table);
    this.fillMenus();

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.table)
  }

  fillListMyMenus() {
    let params: HttpParams = new HttpParams();
    params = params.append('perfilAcessoId', this.grupoId)
    return this.service.searchMenusGrupo(params)
      .toPromise();
  }

  fillListAllMenus() {
    let params: HttpParams = new HttpParams();
    return this.service.searchMenus(params)
      .toPromise();
  }

  onTreeAction(event: any) {
    const row = event.row;
    if (row.treeStatus === 'collapsed') {
      row.treeStatus = 'expanded';
    } else {
      row.treeStatus = 'collapsed';
    }
    this.listMenusTree = [...this.listMenusTree];
  }

  allowRole(data: any) {

    this.addRowData(data);
    if (data.allow) {
      this.handleDisallow(data);
    } else {
      this.handleAllow(data);
    }
  }

  addRowData(data: any) {
    this.rowData.push({
      id: data.id
    });
    if (!data.allow) {
      this.findPaisRecursive(data);
    } else {
      this.findFilhosRecursividade(data);
    }
  }

  findPaisRecursive(data) {
    if (data.roleAcessoPaiId != null) {
      this.rowData.push({
        id: data.roleAcessoPaiId
      });
      this.listMenus.map(item => {
        if (item.id == data.roleAcessoPaiId) {
          item.allow = true;
          item.status = 'Grupo Ativo'
          this.findPaisRecursive(item);
        } else if (item.id == data.id) {
          item.status = 'Ativo'
        }
      }
      );
    } else {
      data.status = 'Grupo Ativo'
    }
  }

  findFilhosRecursividade(data) {
    this.listMenus.map(item => {
      if (item.roleAcessoPaiId == data.id) {
        this.rowData.splice(item.roleAcessoPaiId);
        item.allow = false;
        this.findFilhosRecursividade(item);
      }
    }
    );
  }

  handleAllow(data) {

    // Função recursiva para ativar os descendentes de um item
    const activateDescendants = (parentId) => {

      // Encontra os descendentes do pai na lista
      const descendants = this.listMenus.filter(menu => menu.roleAcessoPaiId === parentId);

      // Ativa os descendentes e chama a função recursivamente para cada um deles
      descendants.forEach(descendant => {
        descendant.allow = true;
        descendant.status = "Ativo";
        descendant.treeStatus = "expanded";
        activateDescendants(descendant.id); // Chamada recursiva para os descendentes do descendente
      });

    };

    // Percorre a lista de menus
    this.listMenus.forEach(menu => {
      // Verifica se o menu clicado é pai de algum outro menu
      if (menu.roleAcessoPaiId === data.id) {
        // Ativa o filho e seus descendentes
        menu.allow = true;
        menu.status = "Ativo";
        menu.treeStatus = "expanded";
        activateDescendants(menu.id); // Ativa os descendentes do filho
      }
    });

  }

  handleDisallow(data) {
    for (const menu of this.rowData) {
      if (data.id === menu.id) {
        const removeInactiveBranches = (accessItems, disableId) => {
          this.disableItemAndDescendants(accessItems, disableId);

          const itemToDisable = accessItems.find(item => item.id === disableId);
          if (itemToDisable && itemToDisable.roleAcessoPaiId !== null) {
            this.checkAndDisableParents(accessItems, itemToDisable.roleAcessoPaiId);
          }
          return accessItems.filter(item => item.allow);
        };

        setTimeout(() => {
          this.listMe = removeInactiveBranches(this.listMenus, menu.id);
        }, 15);
      }
    }
  }

  disableItemAndDescendants(accessItems, itemId) {
    accessItems.forEach(item => {
      if (item.id === itemId) {
        item.allow = false;
        item.status = 'Desativado';
        accessItems.filter(child => child.roleAcessoPaiId === itemId)
          .forEach(child => this.disableItemAndDescendants(accessItems, child.id));
      }
    });
  }

  checkAndDisableParents(accessItems, parentId) {
    const children = accessItems.filter(item => item.roleAcessoPaiId === parentId);
    if (children.every(child => !child.allow)) {
      const parentItem = accessItems.find(item => item.id === parentId);
      if (parentItem) {
        parentItem.allow = false;
        parentItem.status = 'Desativado';
        if (parentItem.roleAcessoPaiId !== null) {
          this.checkAndDisableParents(accessItems, parentItem.roleAcessoPaiId);
        }
      }
    }
  }

  saveGrupoMenuTree() {

    const data = this.formMenusGrupo.value;
    const dataPersist = this.buildDataPersist(data);

    this.service.saveMenusGrupo(
      dataPersist,
      () => {
        this.spinnerLoad = false;
        this.notifications.success('Registro Salvo com sucesso!');
        this.router.navigate(['/pages/gestao-user-terceiro/lista-admin-grupo']);
      },
      (error) => {
        this.notifications.error(error.message);
        this.spinnerLoad = false;
      }
    );
  }

  buildDataPersist(data: any) {
    // Obter os IDs ativados da lista this.listMenus    
    const roleAcessoIds = this.listMenus
      .filter(menu => menu.allow === true)
      .map(menu => menu.id);
    return {
      perfil: {
        id: data.id,
        descricao: data.descricao,
        produtoId: data.produtoId,
        status: data.status
      },
      roleAcessoIds: roleAcessoIds
    };
  }

  async fillMenus() {
    this.spinnerLoad = true;
    await this.populateListGrupoMenus();
    await this.populateListMenus();
    this.mapListMenus();
    this.expandMenus();
    this.buildListMe();
    this.spinnerLoad = false;
    this.setFormValues();
  }

  async populateListGrupoMenus() {
    this.listGrupoMenus = await this.fillListMyMenus() || [];
    this.listGrupoMenus = this.listGrupoMenus.map(value => ({
      id: value.roleAcessoId,
      descricao: String(value.roleAcessoDescricao).toUpperCase()
    }));
  }

  async populateListMenus() {
    this.listMenus = await this.fillListAllMenus() || [];
    this.listMenus = this.listMenus.map(value => ({
      id: value.id,
      descricao: String(value.descricao).toUpperCase(),
      role: value.role,
      treeStatus: 'collapsed',
      roleAcessoPaiId: value.roleAcessoPaiId,
      allow: false,
      status: this.getStatusDescription(value.tipoRoleId),
      tipoRoleDescricao: value.tipoRoleDescricao
    }));
  }

  getStatusDescription(tipoRoleId) {
    if (tipoRoleId === 1) {
      return 'Grupo Desativado';
    } else if (tipoRoleId === 2) {
      return 'Desativado';
    } else {
      return 'Subgrupo Desativado';
    }
  }

  mapListMenus() {
    this.listRegraGrupo = this.listMenus;
    this.listMenusTree = Object.assign([], this.listMenus);
  }

  buildListMe() {
    this.listMe = this.listMenus.filter(menu => menu.treeStatus === 'expanded');
  }

  expandMenus() {
    this.listMenusTree.forEach(menu => {
      this.listGrupoMenus.forEach(menuUsuario => {
        if (menuUsuario.id === menu.id) {
          this.updateMenuProperties(menu);
        }
      });
    });
  }

  updateMenuProperties(menu) {

    menu.treeStatus = 'expanded';
    menu.allow = true;
    if (menu.tipoRoleDescricao === 'MENUS') {
      menu.status = 'Grupo Ativo';
    } else if (menu.tipoRoleDescricao === 'SUB-MENUS') {
      menu.status = 'Ativo';
    } else if (menu.tipoRoleDescricao === 'SUB-MENUS 2 NIVEL') {
      menu.status = 'Subgrupo Ativo';
    }
  }

  setFormValues() {
    const { grupoId, descricao, status, produtoId } = this;
    this.formMenusGrupo.controls['id'].setValue(grupoId);
    this.formMenusGrupo.controls['descricao'].setValue(descricao);
    this.formMenusGrupo.controls['status'].setValue(status);
    this.formMenusGrupo.controls['produto'].setValue(produtoId);
  }

  regrasGrupos(data) {
    let form = this.formMenusGrupo.value;
    setTimeout(() => {
      this.dialogService.open(ModalCancelarGrupoComponent, {
        context: {
          nomeGrupo: null,
          id: this.listRegraGrupo,
          grupo: data,
          frm: form
        },
      }).onClose.subscribe(async () => {
        await this.ngOnInit();
      });
    }, 15);

  }

  previousPage() {
    this.location.back();
  }

  cancel() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}